<div class="table-content">

    <div class="scheduleTable">
        <table>
            <thead>
                <tr>
                    <th>
                        <label class="container checkbox d-flex justify-content-center">
                            <input type="checkbox" [checked]="allSelected" (change)="selectAllRows()">
                            <span class="checkmark"></span>
                        </label>
                    </th>
                    <th>כיתה</th>
                    <th>מספר כיתה</th>
                    <th>סוג תגבור</th>
                    <th>כמות תלמידים</th>
                    <th>סטטוס</th>
                    <th>א'</th>
                    <th>ב'</th>
                    <th>ג'</th>
                    <th>ד'</th>
                    <th>ה'</th>
                    <th>ו'</th>
                    <th class="last-th">ש'</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of pageOfItems" [ngClass]="{ 'row-selected': item._checked == true}">
                    <td class="first-td">
                        <label class="container checkbox d-flex justify-content-center">
                            <input type="checkbox" [(ngModel)]="item._checked" (change)="onSelectRow(item)">
                            <span class="checkmark"></span>
                        </label>
                    </td>
                    <td> {{item.Class}}</td>
                    <td> {{item.ClassCode}} </td>
                    <td>{{item.Classification}}</td>
                    <td>{{item.studentCount}}</td>
                    <td>{{item.Status.viewValue}}</td>
                    <td>{{item.Sunday}}</td>
                    <td>{{item.Monday}}</td>
                    <td>{{item.Tuesday}}</td>
                    <td>{{item.Wednesday}}</td>
                    <td>{{item.Thursday}}</td>
                    <td>{{item.Friday}}</td>
                    <td class="last-th">{{item.Saturday}}</td>
                </tr>
            </tbody>
        </table>

        <div class="tableFooter">
            <jw-pagination [items]="dataSource" (changePage)="onChangePage($event)" [pageSize]="4"></jw-pagination>
            <!-- <div [hidden]="isLoadStudentList" class="sumStudents">סה"כ תלמידים במוסד: {{studentService.ContactsList.length}}
            </div> -->
        </div>
        <div class="tableEmpty" *ngIf="!pageOfItems || pageOfItems.length == 0">לא נמצאו נתונים</div>

    </div>

    <!-- עיצוב טבלה מותאם למובייל -->
    <!-- <div class="datalist">
        <div [hidden]="!isLoadStudentList" class="loading">
            <loaders-css [loader]="dataService.loader" [scale]="2" [color]="dataService.color"></loaders-css>
        </div>
        <div class="accordion" id="accordionExample" *ngIf="!isLoadStudentList">
            <div class="" *ngFor="let s of dataSource; let i=index">
                <div class="" id="{{'heading'+i}}" type="button" [attr.data-toggle]="'collapse'"
                    [attr.data-target]="'#collapse'+i" aria-expanded="false" [attr.aria-controls]="'collapse'+i">

                    <li [ngClass]="{'selected-item':s._checked && selectedStudentIndex==i ,'animated':selectedStudentIndex==i,'animated-reverse':false}"
                        class="list-group-item " (click)="onStudentSelectList(i,s)">
                        <div class="col-4">{{s.ContactNumber}}</div>
                        <div class="col-4">{{s.FullName}}</div>
                        <div class="col-1 list-item-side">...</div>
                        <div class="arrow-icon"></div>
                    </li>
                </div>

                <div id="{{'collapse'+i}}" class="collapse " [attr.aria-labelledby]="'heading'+i"
                    data-parent="#accordionExample">
                    <div class="">
                        <div class="expended-data">
                            <div class="id-number expended-item">
                                <span class="lable col-6">מספר זהות</span>
                                <span class="col-4">{{s.ContactNumber}}</span>
                            </div>
                            <div class="full-name expended-item">
                                <span class="lable col-6">שם מלא</span>
                                <span class="col-4">{{s.FullName}}</span>
                            </div>
                            <div class="class expended-item">
                                <span class="lable col-6">כיתה</span>
                                <span>{{s.new_class1}}</span>
                            </div>
                            <div class="zakaut expended-item">
                                <span class="lable col-6">זכאות להסעה</span>
                                <span class="col-4">{{s.new_zakautleasaa}}</span>
                            </div>
                            <div class="intrested expended-item">
                                <span class="lable col-6">מעוניין בהסעה</span>
                                <span class="col-4">{{s.new_meunianbehasaha}}</span>
                            </div>
                            <div class="father-phone expended-item">
                                <span class="lable col-6">נייד אב</span>
                                <span class="col-4">{{s.FatherPhone}}</span>
                            </div>
                            <div class="mother-phone expended-item">
                                <span class="lable col-6">נייד אם</span>
                                <span class="col-4">{{s.MotherPhone}}</span>
                            </div>
                            <div class="address expended-item">
                                <span class="lable col-6">כתובת</span>
                                <span class="col-4">{{s.Address}}</span>
                            </div>
                            <div class="status expended-item">
                                <span class="lable col-6">סטטוס תלמיד</span>
                                <span class="col-4">{{s.new_contactnewstatus}}</span>
                            </div>
                            <div class="education-type expended-item">
                                <span class="lable col-6">סוג חינוך</span>
                                <span class="col-4">{{s.new_sughinuch}}</span>
                            </div>
                            <div class="schedule expended-item">
                                <span class="lable col-6">מערכת שעות לתלמיד</span>
                                <span class="col-4">{{s.ContactNumber}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>